import algoliasearch from 'algoliasearch'

let client
// let index
let indices = {
  codes_10_cm: undefined,
  codes_o_histology: undefined,
  pathology_diagnoses: undefined
}

/*
const requestOptions = {
  headers: { 'X-Algolia-UserToken': 'user123' }
}
*/

export async function initClient(token) {
  const headers = { Authorization: `Bearer ${token}` }
  const res = await fetch(
    `${process.env.VUE_APP_API_URL}/algolia/credentials`,
    { headers }
  )
  const { clientId, key } = await res.json()
  client = algoliasearch(clientId, key)
}

export async function initIndex(index, token) {
  if (!client) {
    await initClient(token)
  }
  if (indices[index]) {
    return
  }

  indices[index] = client.initIndex(index)
}

export async function search(
  query,
  index,
  token,
  { specialty = '', favourites = false, tumoral = false }
) {
  if (!indices[index]) {
    await initIndex(index, token)
  }

  let filters = specialty ? `specialties:${specialty}` : ''

  if (favourites) {
    filters = filters ? `${filters} AND favourite=1` : 'favourite=1'
  }
  if (tumoral) {
    filters = 'tumoral=1'
  }

  const { hits } = await indices[index].search(query, {
    offset: 0,
    length: 1000,
    filters
  })

  return hits
}
